import React, { useEffect, useRef, useState } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import "./index.css";

// 组件props类型声明
export type HKeyboardProps = {
  options: {
    cb?(data?: string): void;
    onEnterFunc?(): void;
    defaultValue?: string;
    onChangeSelection?(data?: number): void;
    selectionData?: number;
    isTouch?: boolean;
    onChangeTouch?(): void;
  };
};

function HKeyboard({ options }: HKeyboardProps) {
  // 输入框的当前内容和布局状态
  const [inputValue, setInputValue] = useState({
    layoutName: "default",
    input: options.defaultValue || "",
  });
  // 键盘引用
  const keyboard = useRef<any>(null);
  // 当前光标位置
  const [position, setPosition] = useState(options.defaultValue?.length || 0);

  // 输入内容变化时更新
  function onChange(data: string) {
    setInputValue({
      ...inputValue,
      input: data,
    });
    if (options.cb) {
      options.cb(data);
    }

    // 判断是增加还是减少字符
    if (data.length > inputValue.input.length) {
      setPosition(position + 1);
    } else {
      setPosition(position - 1);
    }
  }

  // 切换大小写
  let handleShift = () => {
    const layoutName = inputValue.layoutName;
    setInputValue({
      ...inputValue,
      layoutName: layoutName === "default" ? "shift" : "default",
    });
  };

  // 光标位置变化时回调
  useEffect(() => {
    if (options.onChangeSelection) {
      options.onChangeSelection(position);
    }
  }, [position]);

  // 处理特殊按键
  function onKeyPress(button: string) {
    keyboard.current.setCaretPosition(position);
    switch (button) {
      case "{lock}":
      case "{shift}":
        handleShift();
        break;
      case "{enter}":
        if (!inputValue.input) return false;
        if (options.onEnterFunc) {
          options.onEnterFunc();
        }
        break;
      case '{arrowleft}':
        setPosition(position - 1 < 0 ? 0 : position - 1);
        break;
      case '{arrowright}':
        setPosition(position + 1 > inputValue.input.length ? inputValue.input.length : position + 1);
        break;
    }
  }

  // 组件初次渲染时设置默认输入内容
  useEffect(() => {
    if (keyboard.current) {
      keyboard?.current?.setInput(options.defaultValue);
    }
  }, []);

  // 外部传入选中位置时同步
  useEffect(() => {
    if (options.selectionData !== undefined) {
      setPosition(options.selectionData);
      if (options.onChangeTouch) {
        options.onChangeTouch();
      }
    }
  }, [options.selectionData, options.isTouch]);

  return (
    // 外层div设置了高度为400px（主要调整处） 
    <div
      className="flex absolute inset-x-0 bottom-0 w-4/4 m-auto"
    >
      {/* 键盘本身也需100%高度占满父元素 */}
      <Keyboard
        keyboardRef={(r) => (keyboard.current = r)}
        theme={"hg-theme-default myTheme1"}
        layoutName={inputValue.layoutName}
        onChange={onChange}
        onKeyPress={onKeyPress}
        layout={{
          default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
            "q w e r t y u i o p [ ] \\",
            "{lock} a s d f g h j k l ; ' {enter}",
            "{shift} z x c v b n m , . / {shift}",
            ".com @ {space} {arrowleft} {arrowright}"
          ],
          shift: [
            "~ ! @ # \$ % ^ & * ( ) _ + {bksp}",
            "Q W E R T Y U I O P { } |",
            '{lock} A S D F G H J K L : " {enter}',
            "{shift} Z X C V B N M < > ? {shift}",
            ".com @ {space} {arrowleft} {arrowright}",
          ],
        }}
        display={{
          "{bksp}": "Delete",
          "{enter}": "Enter",
          "{shift}": "Shift",
          "{space}": "Space",
          "{lock}": "Lock",
          "{arrowleft}": "←",
          "{arrowright}": "→",
        }}
        // 让键盘组件高度继承外层div
        style={{
          height: "100%",
          minHeight: "100%",
          maxHeight: "100%",
        }}
      />
    </div>
  );
}

export default HKeyboard;
